<template>
    <div>
    <back-btn />
    <v-card>
      <v-card-text>
        <h2>Complementary Patient Export</h2>
        <v-row>
          <v-col lg="4">
            <label>Month <require-sign /></label>
                  <v-select
                    class="mr-1"
                    :items="export_months"
                    v-model="month"
                    item-text="text"
                    :error-messages="monthValidation"
                    item-value="value"
                    dense
                    outlined
                  ></v-select>
          </v-col>
          <v-col lg="4">
            <label>Year <require-sign /></label>
                <v-select
                class="mr-1"
                :items="years"
                v-model="year"
                item-text="text"
                item-value="value"
                :error-messages="yearValidation"
                dense
                outlined
                ></v-select>
          </v-col>
          <v-col lg="4"><br>
          <v-btn class="form-btn" @click="exportData">
              <v-icon left>mdi-chevron-right-circle-outline</v-icon>Export
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      
    </v-card>
  </div>
  </template>
  
  <script>
  import { mapState } from "vuex";
  import { ValidationMixin } from "./../../mixins/ValidationMixin";
  import BackBtn from "@/components/navigation/BackBtn.vue";
  import { required } from "vuelidate/lib/validators";
  import RequireSign from "@/components/notification/RequireSign.vue";
  
  export default {
    components: { BackBtn,RequireSign },
    mixins: [ValidationMixin],
    data: () => ({
        month: new Date().getMonth() + 1,
        year: 2025,
        township_group_id: null,
    }),
    validations: {
    month: {
      required,
    },
    year: {
      required,
    },
  },
  computed: {
    ...mapState("InitialData", ["export_months", "years"]),
    ...mapState("Admin", ["admin"]),
    monthValidation() {
      return this.handleFieldErrors(this.$v.month);
    },
    yearValidation() {
      return this.handleFieldErrors(this.$v.year);
    },
  },
    methods: {
        exportData() {
        if (this.$v.$invalid) {
            this.$toast.error("Please fill in all required fields.", { timeout: 2000 });
            return;
        }

        const data = {
            month: this.month,
            year: this.year,
        };

        if (this.admin && this.admin.township_group_id) {
            data.township_group_id = this.admin.township_group_id;
        }

        this.$store
            .dispatch("Patient/getComplementaryExport", data)
            .then(() => {
            this.$toast.success("Export successful!", { timeout: 2000 });
            })
            .catch((error) => {
            this.$toast.error("Export failed. Please try again.", { timeout: 2000 });
            console.error(error);
            });
        },
    },
  };
  </script>
  
  <style scoped></style>
  